import Modal from 'shared/Modal';
import styled from 'styled-components';
import { Button, Box, TextField } from '@mui/material';
import { ModalBaseProps } from 'types';

type ModalProps = ModalBaseProps & {
  onConfirm?: () => void;
  headerText?: string | React.ReactNode;
  Body?: React.ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  closeOnConfirm?: boolean;
  onCancelCallback?: () => void;
  onConfirmButtonClassNames?: string;
  hideConfirmButton?: boolean;
  disableConfirmButton?: boolean;
  disableCancelButton?: boolean;
  height?: number;
  width?: number;
};

const defaultHeaderText = 'Change headerText props to replace this text';

const defaultCancelText = 'Cancel';

const defaultConfirmText = 'Confirm';

const SimpleModal = ({
  open,
  onClose,
  headerText,
  Body,
  cancelButtonText,
  confirmButtonText,
  onConfirm,
  closeOnConfirm,
  onCancelCallback,
  onConfirmButtonClassNames = '',
  hideConfirmButton = false,
  disableConfirmButton = false,
  disableCancelButton = false,
  height,
  width = 600,
}: ModalProps) => {
  const onCancel = () => {
    onClose();

    if (onCancelCallback) {
      onCancelCallback();
    }
  };

  const onConfirmButtonClick = () => {
    if (onConfirm) {
      onConfirm();
    }

    if (closeOnConfirm) {
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} modalHeight={height} modalWidth={width}>
      <Box>
        <Box component={'h3'}>{headerText ?? ''}</Box>
        {Body ?? null}
        <Box
          sx={{
            textAlign: 'right',
          }}
        >
          <StyledButton onClick={onCancel} disabled={disableCancelButton}>
            {cancelButtonText ?? defaultCancelText}
          </StyledButton>
          {!hideConfirmButton ? (
            <StyledButton
              className={onConfirmButtonClassNames}
              onClick={onConfirmButtonClick}
              color="primary"
              disabled={disableConfirmButton}
            >
              {confirmButtonText ?? defaultConfirmText}
            </StyledButton>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default SimpleModal;

const StyledButton = styled(Button)`
  text-transform: none;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.15s ease;
  margin-left: 8px;

  &.MuiButton-outlined {
    border-color: ${(props: any) => props.theme.palette.divider};
    &:hover {
      border-color: ${(props: any) => props.theme.palette.action.disabled};
      background: ${(props: any) => props.theme.palette.action.hover};
    }
  }

  &.red-warning-button {
    color: ${(props: any) => props.theme.palette.error.contrastText};
    background-color: ${(props: any) => props.theme.palette.error.main};
    &:hover {
      background-color: ${(props: any) => props.theme.palette.error.dark};
    }
  }

  &.blue-warning-button {
    color: ${(props: any) => props.theme.palette.primary.contrastText};
    background-color: ${(props: any) => props.theme.palette.primary.main};
    &:hover {
      background-color: ${(props: any) => props.theme.palette.primary.dark};
    }
  }

  &.red-warning-text {
    color: ${(props: any) => props.theme.palette.error.main};
  }
`;
